import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/domain/item-page-data'

import { ItemPageUserInfoActionsPluginModel } from './types'

export const getItemPageUserInfoActionsPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageUserInfoActionsPluginModel => ({
  sellerId: itemDto.user.id,
  closetCountdownEndDate: itemDto.user.closet_countdown_end_date,
  isFavourite: itemDto.user.is_favourite,
})

export const getServerItemPageUserInfoActionsPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageUserInfoActionsPluginModel => ({
  sellerId: sidebarDto.seller_id,
  closetCountdownEndDate: sidebarDto.closet_countdown_end_date,
  isFavourite: sidebarDto.is_favourite,
})
